import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {MonomerVisualSymbol} from 'graphql-client/__generated/graphqlGlobalTypes';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

import ModifiedPhosphate from './ModifiedPhosphate';
import {MONOMER_VISUAL_SYMBOL_DISPLAY_NAME, RECOMMENDED_CUSTOM_VISUAL_SYMBOLS} from './MonomerConstants';

interface MonomerVisualSymbolDropdownProps {
  selectedSymbol: MonomerVisualSymbol;
  onSelectSymbol: (color: string) => void;
  monomerId?: string;
  isDisabled?: boolean;
}

export default function MonomerVisualSymbolDropdown({
  selectedSymbol,
  monomerId,
  onSelectSymbol,
  isDisabled,
}: MonomerVisualSymbolDropdownProps): JSX.Element {
  return (
    <Dropdown
      key={monomerId}
      menu={
        <Menu height={MenuHeight.MEDIUM} width={MenuWidth.MEDIUM} scrollable={true}>
          {RECOMMENDED_CUSTOM_VISUAL_SYMBOLS.map((symbol) => (
            <Option
              key={symbol}
              value={symbol}
              isSelected={symbol === selectedSymbol}
              onSelect={onSelectSymbol}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="modifiedPhosphate" width="10" height="10">
                <ModifiedPhosphate size={10} offsetX={0} offsetY={0} symbol={symbol} />
              </svg>
              <span className={css(styles.symbolOption)}>{MONOMER_VISUAL_SYMBOL_DISPLAY_NAME[symbol]}</span>
            </Option>
          ))}
        </Menu>
      }
    >
      <Button
        hideDropdownCaret={false}
        isDropdown={true}
        size={ButtonSize.SMALL}
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        disabled={isDisabled}
        icon={
          <svg xmlns="http://www.w3.org/2000/svg" className="modifiedPhosphate" width="14" height="14">
            <ModifiedPhosphate size={10} offsetX={0} offsetY={0} symbol={selectedSymbol} />
          </svg>
        }
        dataTestAttrs={{
          component: 'MonomerVisualSymbolDropdown',
          element: 'dropdownButton',
        }}
      />
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  symbolOption: {
    marginLeft: '8px',
  },
});
